import { render, staticRenderFns } from "./GoToAppModal.vue?vue&type=template&id=1d566bbd"
import script from "./GoToAppModal.vue?vue&type=script&lang=js"
export * from "./GoToAppModal.vue?vue&type=script&lang=js"
import style0 from "./GoToAppModal.vue?vue&type=style&index=0&id=1d566bbd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports